import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TaskServiceInterface } from './definitions/task-service-interface';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

export interface CancelTaskResponse {
  task: {
    cancel: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TaskCancelService {
  constructor(private apollo: Apollo) {}

  public cancel(
    taskId: string,
    reason: string,
    mutation: DocumentNode
  ): Observable<FetchResult<CancelTaskResponse>> {
    return this.apollo.mutate<CancelTaskResponse>({
      mutation,
      variables: {
        id: taskId,
        reason,
      },
    });
  }
}
